import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';
export const GolfIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    width: props.width || '21',
    height: props.height || '21',
    fill: props.fill || '#43494F',
  };
  return (
    <svg viewBox='0 0 21 21' {...svgProps} xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3409_212311)'>
        <path
          d='M10.5 8.74975C9.32488 8.74847 8.15251 8.86336 7 9.09275V7.04612L13.0506 3.98887L7.90475 0.262248L7.7875 0.185248C7.52057 0.05074 7.22363 -0.0131546 6.925 -0.000345199C6.62637 0.0124642 6.336 0.101551 6.08157 0.258422C5.82714 0.415293 5.61712 0.634719 5.47155 0.895782C5.32598 1.15684 5.24971 1.45084 5.25 1.74975V9.5495C2.09212 10.5951 0 12.5647 0 14.8747C0 18.3091 4.61212 20.9998 10.5 20.9998C16.3879 20.9998 21 18.3091 21 14.8747C21 11.4404 16.3879 8.74975 10.5 8.74975ZM7 1.7655L9.69938 3.72112L7 5.08525V1.7655ZM10.5 19.2498C5.7575 19.2498 1.75 17.246 1.75 14.8747C1.75 13.48 3.14213 12.2156 5.25 11.408V14.8747H7V10.8821C8.14903 10.6262 9.32281 10.498 10.5 10.4997C15.2425 10.4997 19.25 12.5035 19.25 14.8747C19.25 17.246 15.2425 19.2498 10.5 19.2498ZM14.875 14.8747C14.875 15.2209 14.7724 15.5592 14.5801 15.847C14.3878 16.1348 14.1145 16.3591 13.7947 16.4915C13.4749 16.624 13.1231 16.6586 12.7836 16.5911C12.4441 16.5236 12.1323 16.3569 11.8876 16.1122C11.6428 15.8674 11.4761 15.5556 11.4086 15.2162C11.3411 14.8767 11.3758 14.5248 11.5082 14.2051C11.6407 13.8853 11.865 13.612 12.1528 13.4197C12.4405 13.2274 12.7789 13.1247 13.125 13.1247C13.5891 13.1247 14.0342 13.3091 14.3624 13.6373C14.6906 13.9655 14.875 14.4106 14.875 14.8747Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

GolfIcon.iconType = ICON_TYPES.GOLF_ICON;
